import { Box, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import form from '../../assets/others/feedback-form.jpg';
import AppHeader from "../../components/nav/AppHeader";
import BottomNav from "../../components/nav/BottomNav";
import { sendReactGAPageView } from "../../consts/helpers";

export default function FeedbackHome() {
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'Give Feedback');
    }, [pathname])

    return (
        <>
            <AppHeader />
            <Typography variant="h5" gutterBottom>Give Feedback</Typography>

            <Stack spacing={2}>
                <CategoryCard photo={form} title={'Fill up a feedback form'} path={'/feedback/form'}/>
                {/* <CategoryCard photo={chat} title={'Chat with us'} path={'/feedback/chat'}/> */}
            </Stack>

            <BottomNav />
        </>
    )
}

const CategoryCard = ({ photo, title, path }) => {
    const navigate = useNavigate();
    return (
        <Stack direction={'row'}
            sx={{ backgroundColor: 'var(--pri-green)', borderRadius: '32px', cursor: 'pointer',
                transition: 'box-shadow 0.5s, transform 0.5s',
                '&:hover' : {
                    transform: 'translate(-4px,-4px)',
                    boxShadow: '4px 4px var(--dark-green)'
                }
            }}
            onClick={()=>navigate(path)}
        >
            <Box sx={{ height: '125px', maxWidth: '50%', borderRadius: '32px 0 0 32px', aspectRatio: 1, background: `var(--light-green) url(${photo}) no-repeat center`, backgroundSize: 'cover' }} />

            <Box className='centered-container' sx={{ width: '100%', p: 2, textAlign: 'center' }}>
                <Typography variant='subtitle1'>
                    { title }
                </Typography>
            </Box>
        </Stack>
    )
}